import { render, staticRenderFns } from "./TaxonomyRestrictions.vue?vue&type=template&id=949146f6&"
import script from "./TaxonomyRestrictions.vue?vue&type=script&lang=ts&"
export * from "./TaxonomyRestrictions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports